import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";

import {
  FiUser,
  FiCalendar,
  FiChevronRight,
  FiHome,
  FiDollarSign,
} from "react-icons/fi";

import { getMyWithdrawals } from "../../store/slices/fund";

const WithdrawReport = () => {
  const dispatch = useDispatch();


  const {
    withdrawals,
    withdrawalsLoading,
    withdrawalsError,
  } = useSelector((state) => state.fund);


  useEffect(() => {
    dispatch(getMyWithdrawals());
  }, [dispatch]);


  const withdrawalList = Array.isArray(withdrawals)
    ? withdrawals
    : [];


  const formatDate = (date) => {
    if (!date) {
      return "-";
    }

    const parsedDate = new Date(date);

    if (Number.isNaN(parsedDate.getTime())) {
      return "-";
    }

    return parsedDate.toLocaleString("en-IN", {
      dateStyle: "medium",
      timeStyle: "short",
    });
  };


  const formatNumber = (number) => {
    return Number(number || 0).toLocaleString("en-IN", {
      maximumFractionDigits: 2,
    });
  };

  return (
    <div className="gi-referral-page">


      <div className="gi-breadcrumb">

        <Link to="/dashboard">
          <FiHome />
          Dashboard
        </Link>

        <FiChevronRight className="gi-breadcrumb-arrow" />

        <span>
          Withdrawal
        </span>
        <FiChevronRight className="gi-breadcrumb-arrow" />

        <span>
          Withdraw Report
        </span>



      </div>

      <section className="gi-referral-table-card">

        <div className="gi-referral-table-wrapper">

          <table className="gi-referral-table">

            <thead>

              <tr>

                <th>#</th>

                <th>

                  Amount
                </th>

                <th>

                  Order Id
                </th>

                <th>

                  Date
                </th>

                <th>Status</th>

              </tr>

            </thead>

            <tbody>

              {withdrawalsLoading && (

                <tr>

                  <td
                    colSpan="5"
                    className="gi-table-message"
                  >
                    Loading withdrawal report...
                  </td>

                </tr>

              )}


              {!withdrawalsLoading &&
                withdrawalsError && (

                  <tr>

                    <td
                      colSpan="5"
                      className="gi-table-message"
                    >
                      {withdrawalsError}
                    </td>

                  </tr>

                )}


              {!withdrawalsLoading &&
                !withdrawalsError &&
                withdrawalList.length === 0 && (

                  <tr>

                    <td
                      colSpan="5"
                      className="gi-table-message text-center"
                    >
                      No withdrawal report found!
                    </td>

                  </tr>

                )}


              {!withdrawalsLoading &&
                !withdrawalsError &&
                withdrawalList.map((item, index) => (

                  <tr
                    key={
                      item?._id ||
                      index
                    }
                  >


                    <td className="gi-referral-number">

                      {String(
                        index + 1
                      ).padStart(2, "0")}

                    </td>

                    {/* AMOUNT */}

                    <td>

                      <strong className="gi-income-amount">

                        $
                        {formatNumber(
                          item?.amount
                        )}

                      </strong>

                    </td>

                    {/* ORDER ID */}

                    <td>

                      <span className="gi-user-id">

                        {item?._id || "-"}

                      </span>

                    </td>

                    {/* DATE */}

                    <td>

                      <span className="gi-date-text">

                        {formatDate(
                          item?.createdAt
                        )}

                      </span>

                    </td>

                    {/* STATUS */}

                    <td>

                      <span
                        className={`gi-status-badge ${item?.status
                          ?.toLowerCase() || ""
                          }`}
                      >

                        <span className="gi-status-dot" />

                        {item?.status || "-"}

                      </span>

                    </td>

                  </tr>

                ))}

            </tbody>

          </table>

        </div>

      </section>

    </div>
  );
};

export default WithdrawReport;